export default __webpack_public_path__ + "static/media/realy_logo.2b412aa0.svg";